import { render, staticRenderFns } from "./RestaurantMoreRestaurantsStats.vue?vue&type=template&id=29d4532a&scoped=true"
import script from "./RestaurantMoreRestaurantsStats.vue?vue&type=script&lang=js"
export * from "./RestaurantMoreRestaurantsStats.vue?vue&type=script&lang=js"
import style0 from "./RestaurantMoreRestaurantsStats.vue?vue&type=style&index=0&id=29d4532a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d4532a",
  null
  
)

export default component.exports